<template>
  <div>
    <general-textarea
      label="Label"
      ref="labelForCefrSegmentContentDataInput"
      dense autofocus rows="1" no-resize
      v-model="$_label"
      v-bind:disabled="isImmutable"
      v-on:input="$_updateHeight"
    >
    </general-textarea>

    <general-text-field
      label="Topic"
      dense
      v-bind:disabled="isImmutable"
      v-model="$_topic"
    >
    </general-text-field>
  </div>
</template>

<script>
import { SegmentContentDataInputDefinition, GeneralTextField, GeneralTextarea } from '@Scatt'
import LabelForCefrSegmentData from '../../../modules/segmentDataTypes/LabelForCefrSegmentData.js';

export default {
  segmentContentDataInputDefinition: new SegmentContentDataInputDefinition(
    'LabelForCefrSegmentContentDataInput',
    LabelForCefrSegmentData.contentData,
  ),

  model: {
    event: 'update',
    prop: 'timelineSegmentContentData'
  },

  components: {
    GeneralTextField,
    GeneralTextarea,
  },

  props: {
    isImmutable:                { type: Boolean,                             required: true },
    timelineSegmentContentData: { type: LabelForCefrSegmentData.contentData, required: true },
  },

  data() {
    return {
      $_textareaElement: undefined,
    };
  },

  computed: {
    $_labelData: {
      get()          { return this.timelineSegmentContentData },
      set(labelData) { this.$emit('update', labelData) },
    },

    $_label: {
      get()      { return this.$_labelData.label },
      set(label) {
        let labelData = this.$_labelData.clone();
        labelData.label = label;
        this.$_labelData = labelData;
      },
    },

    $_topic: {
      get()      { return this.$_labelData.topic },
      set(topic) {
        let labelData = this.$_labelData.clone();
        labelData.topic = topic;
        this.$_labelData = labelData;
      },
    },
  },

  mounted() {
    this.$data.$_textareaElement = this.$refs.labelForCefrSegmentContentDataInput.$refs.input;
    this.$_updateHeight();
  },

  methods: {
    $_updateHeight() {
      this.$data.$_textareaElement.style.height = '';
      this.$nextTick(() => {
        this.$data.$_textareaElement.style.height = `${this.$data.$_textareaElement.scrollHeight}px`;
      });
    },
  },
}
</script>
